module.exports = __webpack_public_path__ + "static/media/owner.8e1eb85e.png";